/**
 * File: WeblinkController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class WeblinkController {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}

        let userId = localStorageService.get("user_id")
        let planId = $state.params.planId;
        let resourceId = $state.params.resourceId;
        let plan = localStorageService.get("currentPlan")
        var save_url = TPWIZARDCONSTANT.API_SAVE_WEBLINK

        var validate = (resource) => {
            let errorCount = 0
            if (resource.web_note === null || resource.web_note === undefined || resource.web_note === "") {
                $scope.errors["web_note"] = "Please Enter book web_note"
                errorCount++;
            }
            if (resource.web_link === null || resource.web_link === undefined || resource.web_link === "") {
                $scope.errors["web_link"] = "Please Enter web link"
                errorCount++;
            } else {
                var pattern = /((?:https?\:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/i;
                if (!pattern.test(resource.web_link)) {
                    $scope.errors["web_link"] = "Please Enter a valid link";
                    errorCount++;
                }
            }
            return errorCount;
        }

        $scope.addResource = () => {
            var resource = {
                web_note: $scope.resource.web_note.trim(),
                web_link: $scope.resource.web_link.trim()
            }
            $scope.errors = {}
            var errorCount = validate(resource);
            if (errorCount === 0) {
                authService.callAPI(save_url, "POST", {
                    tp_id: planId,
                    _id: resourceId,
                    title: $scope.resource.title,
                    web_note: $scope.resource.web_note,
                    web_link: $scope.resource.web_link,
                    status: $scope.resource.status,
                    user_id: userId
                }, (response) => {
                    if (response && response.result && response.result.data) {
                        var result = response.result.data;
                        toastr.success("Web Link added successfully")
                        localStorageService.set("currentPlan", result)    
                        $rootScope.setStatus(resourceId, 'created')
                        _.defer(function() { $scope.$apply(); });
                    } else {
                        toastr.error("Network Error, please try later.")
                    }
                })
            }
        }

        $scope.resetResource = () => {
            $scope.resource.web_note = "";
            $scope.resource.web_link = "";
            $scope.errors = {};
        }

        var loadTemplate = () => {
            if (plan) {
                $scope.resource = _.find(plan.resources, function(res) {
                    return res._id === resourceId
                })
                _.defer(() => { $scope.$apply(); });
            }
        }

         /*Roles and Privilege*/
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "weblinks"
        })
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[tpObj.feature_id] = user_access;
            })
            loadTemplate()
        }

    };
}

export default WeblinkController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/resources/weblinks.js